//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import PanierList from '../../../components/location/panierList/PanierList.jsx';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

// API fetch
import axios from "axios";
import { baseURL, phpURL, appURL } from '../../../config/api-config.js';


//Translate utils :
import { translator } from "../../../utils/translator.js"
//Utils 
import { getTotalPanier, getArticlePU, tarifDecimalConverter } from '../../../utils/calcul-tarif'

import { poucesConvertor } from "../../../utils/poucesConvertor.js"

import convertHoraire from '../../../utils/convert_horaire'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'

//// - we get infos from the DB to show editables infos for a Resa ////
function LocationPayment() { // full page as component imported in router

    const { refLoc, idLoc } = useParams(); //id of the selected resa, in url (as string)

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [currentLoc, setCurrentLoc] = useState({});

    const lang = "fr" //global state : shopping step

    const [panier, setPanier] = useState([])
    const [client, setClient] = useState({})
    const [dbArticles, setDbArticles] = useState([])
    const [dbTailles, setDbTailles] = useState([])
    const [reponseCommentaire, setReponseCommentaire] = useState("")
    let [loading, setLoading] = useState(false);
    let [match, setMatch] = useState(false);
    const [signature, setSignature] = useState(false);
    const [confirmMode, setConfirmMode] = useState(false);
    const [cguOpen, setCguOpen] = useState(false);


    const handleChange = (event) => {
        setSignature(event.target.checked);
    };

    //// -- At first render :
    useEffect(() => {

        /* 
                if (checkLogin() === false) {
                    navigate(`/manager/login?dest=manager`)
                } */


        async function initArticles() {
            const resp = await axios.get(`${baseURL}/article`);
            setDbArticles(resp.data);
            console.log(resp.data)

            initTailles()
        }
        initArticles()

        async function initTailles() {
            const resp = await axios.get(`${baseURL}/taille`);
            setDbTailles(resp.data);

            initLocation()
        }


        async function initLocation() {
            try {

                const resp = await axios.get(`${baseURL}/location/${idLoc}`);
                //console.log(resp.data)
                setCurrentLoc(resp.data);
                setConfirmMode(resp.data.solde === 0)
                //control "sécu"
                if (resp.data.ref_location !== refLoc) {
                    console.log('erreur ref');
                    navigate(`/location`)
                }
            }
            catch (error) {
                console.log('erreur ref');
                navigate(`/location`)
            }
        }


    }, [])
    //// --

    //// -- At first render :
    useEffect(() => {

        if (currentLoc.Client) {
            setClient(currentLoc.Client);
        }
        if (currentLoc.Paniers) {
            setPanier(currentLoc.Paniers);
        }

        /* if (currentLoc.created !== currentLoc.updatedAt) { //location déjà répondue
            //Next step
            navigate(`/location/match-confirm/${refLoc}/${idLoc}`)
        } */

    }, [currentLoc])
    //// --


    function TextCGV() {

        return (
            <pre>En cochant, j'accepte les <span onClick={_=>setCguOpen(true)}>conditions de location</span></pre>
        )
    }





    return (
        <div className="bg-relative">
            <Background ind={3} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner mode="location" />

                    {currentLoc.match === true ?


                        <section>

                            {confirmMode === true ?

                                <div className="main-container">

                                    <div className="location-step3-infos-periode">
                                        <h3>La banque a confirmé votre paiement</h3>

                                    </div>
                                </div>
                                :
                                <>
                                    <div className="main-container">

                                        <div className="location-step3-infos-periode">
                                            <h3>Payez dès maintenant pour finaliser votre location de matériel</h3>

                                            <div className="location-paiement-cgv">
                                                <p className="location-paiement-cgv-intro">Payez en ligne dès maintenant pour finaliser votre location, ainsi vous n'aurez plus rien à régler une fois sur place, dans la pinède de la plage du Lion. </p>
                                                



                                            </div>
                                        </div>
                                    </div>
                                    <div className="main-container">
                                        <div className="location-paiement-total">
                                            <h3>Total à payer : {tarifDecimalConverter(currentLoc.total)}€</h3>
                                            {
                                                signature === false &&
                                                <p>Vous devez accepter les CGU pour pour passer au paiement</p>
                                            }
                                            <div className="location-paiement-check">
                                            <FormGroup>
                                                <FormControlLabel control={<Checkbox
                                                    checked={signature}
                                                    onChange={handleChange}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                    />} label="" />
                                            </FormGroup>
                                            <TextCGV />
                                            </div>
                                        </div>
                                                {cguOpen ===true &&  
                                                <div className="location-paiement-cgv-content">
                                                    <p>{`1- Tout le matériel de location doit être effectué en échange d’un dépôt de garantie comme une pièce d’identité, passeport, permis de conduire ou clés de voitures.`}</p>
                                                    <p><i>All rental equipment must be made in exchange for a security deposit such as ID, passport, driver’s license or car keys</i></p>
                                                    <p>{`2- En cas de dommages causés à soi ou à autrui pendant la durée de la location du matériel, votre responsabilité est engagée, même en cas de casse ou de perte du matériel.`}</p>
                                                    <p><i>In the event of damage caused to oneself or to the others during the rental period of the equipment, your responsability is engaged, even in the event of breakage or loss of the equipment</i></p>
                                                    <p>{`3- Interdiction d’utiliser le matériel de location dans la zone de baignade, située entre les deux drapeaux sauf pour les bodyboarders sans palme.`}</p>
                                                    <p><i>Prohibition to use rental equipment in the swimming area, located by the two flags except for bodyboarders without fins.</i></p>
                                                    <p>{`4- Le loueur peut suspendre toute location s’il estime que les conditions ne sont pas favorables ou trop dangereuses.`}</p>
                                                    <p><i>The rental company may suspend any rental if it considers that the conditions are not favorable or too dangerous</i></p>
                                                    <p>{`5- Merci de cocher ci dessous pour attester que vous avez bien pris connaissance des conditions ci-dessus, bon surf et merci de ramener le materiel. sans sable s’il vous plait.`}</p>
                                                    <p><i>Please, check to certify that you are aware of the above conditions, good surfing and please bring the equipment without sand.</i></p>
                                                </div> 
                                                }
                                        <div className="location-matcher-boutons-container">
                                            <form method="POST" action={phpURL + "nestor/paiement_location.php"}>
                                                {/* <form method="POST" action={"http://localhost:4000/Applications/MAMP/htdocs/nestor/2024/nestor-surf/v2_loc/frontend_nestorsurf/src/php/paiement_location.php"}> */}
                                                <input type="hidden" name="post_total" value={currentLoc.total} />
                                                <input type="hidden" name="post_numResa" value={currentLoc.ref_location} />
                                                <input type="hidden" name="post_email" value={client.email} />
                                                <input type="hidden" name="post_idResa" value={currentLoc.id_location} />
                                                <input type="hidden" name="post_idClient" value={currentLoc.client_id} />
                                                <input type="hidden" name="post_baseURL" value={baseURL} />
                                                <input type="hidden" name="post_appURL" value={appURL} />
                                                <input type="hidden" name="post_billing_firstname" value={client.prenom} />
                                                <input type="hidden" name="post_billing_lastname" value={client.nom} />
                                                <input type="hidden" name="post_shoppingcart" value={String(panier.length)} />

                                                <div className="location-matcher-boutons-item">
                                                    <Button
                                                        fullWidth
                                                        disabled={!signature}
                                                        type="submit"
                                                        className="bt-reponse-refuse"
                                                        variant="contained">
                                                        Payer en ligne
                                                    </Button>
                                                </div>


                                            </form>


                                        </div>
                                    </div>
                                </>
                            }

                            <div className="main-container">

                                <div className="location-step3-infos-periode">
                                    <h3>Durée de location</h3>

                                    <div className="location-step3-infos-periode-content">
                                        <div>
                                            <p>Du {dayjs(currentLoc.d1).format("dddd DD/MM")} à {convertHoraire(currentLoc.h1, "horaire")}</p>
                                        </div>
                                        <div>
                                            <p>Au {dayjs(currentLoc.d2).format("dddd DD/MM")} à {convertHoraire(currentLoc.h2, "horaire")}</p>
                                        </div>
                                        <div>
                                            <h4>soit {getDureeInfos(calculDuree(currentLoc))}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="main-container">

                                <div className="location-step3-panier-title">
                                    <h3>Le panier</h3>

                                </div>
                                <PanierList dbArticles={dbArticles} dbTailles={dbTailles} panierAMatcher={panier} locAMatcher={currentLoc} />

                            </div>
                            <div className="main-container">

                                <div className="location-step3-infos-client">
                                    <h3>Vos coordonnées</h3>

                                    <div className="location-step3-infos-client-content">
                                        <div>
                                            <h4>{client.prenom + " " + client.nom}</h4>
                                            <p>{"Téléphone : " + client.tel}</p>
                                            <p>{"Email : " + client.email}</p>

                                        </div>
                                        <div>
                                            <p>{"Téléphone 2 : " + client.tel2}</p>
                                            {client.adresse_vacances != "" ?
                                                <p>{"Adresse de vacances : " + client.adresse_vacances}</p>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>



                        </section>

                        :
                        <section>

                            <div className="main-container">

                                <div className="location-step3-infos-periode">
                                    <h3>Vous ne pouvez pas payer cette location car elle n'a pas été validée</h3>

                                    <div className="location-step4">
                                        <div className="location-step4-content">

                                            <p>Nous allons étudier votre demande et vous répondre très rapidement.</p>

                                        </div>

                                        <Button
                                            className="bottom-nav-prev"
                                            onClick={_ => navigate('/location')}
                                            variant="contained">
                                            <KeyboardReturnIcon />{translator("Revenir à l'accueil", lang, "BtPrevious")}
                                        </Button>
                                    </div>
                                </div>
                            </div>


                        </section>
                    }



                </div>
            </main>

        </div>

    );
}

export default LocationPayment;

